export interface GuidanceAndAdvice {
    riskAndStaticQuestion: any[];
}